import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserDto } from '../../dtos';
import { useFailedCreateSnackbar, useSuccessfulCreateSnackbar } from '../../Components/CoreLib/library';
import { useCreateUserMutation } from '../../store/generated/generatedApi';
import { UserForm } from '../../Components/Forms/UserForm';

export const AddUserView: FC = () => {
    const navigate = useNavigate();
    const [createUser, { data, isError, isSuccess, reset }] = useCreateUserMutation();

    useSuccessfulCreateSnackbar('User', isSuccess, () => navigate(`/user/${data?.id}`));
    useFailedCreateSnackbar('user', isError, reset)

    const handleSave = (values: UserDto) => {
        createUser(values);
    };

    const handleCancel = () => {
        navigate('/users');
    };

    return <UserForm save={handleSave} cancel={handleCancel} />;
};
